import React from 'react';
import { Flex, Loader } from '@grubhubprod/gh-cookbook-react/dist';

type CreditCardFormIframeProps = {
  id: string;
  isLoadingComponent?: boolean;
};

export const CreditCardFormIframe: React.FC<CreditCardFormIframeProps> = ({
  id,
  isLoadingComponent,
}) => {
  return (
    <>
      <div id={id} data-testid={id} />
      {isLoadingComponent && (
        <Flex alignItems="center" justifyContent="center" width="100%">
          <Loader size="md" />
        </Flex>
      )}
    </>
  );
};
